import { fetchWithAuth } from '@/lib/fetchWithAuth';

export interface CadastroPendente {
  id: string;
  nome: string;
  email: string;
  telefone: string;
  cidade: string;
  estado: string;
  cpf: string | null;
  status: 'pendente' | 'aprovado' | 'rejeitado' | 'aguardando_email';
  created_at: string;
  aprovado_por: string | null;
  aprovado_em: string | null;
  rejeitado_por: string | null;
  rejeitado_em: string | null;
  motivo_rejeicao: string | null;
  profile_id: string | null;
}

export const cadastrosPendentesService = {
  async listarPendentes(): Promise<CadastroPendente[]> {
    const res = await fetchWithAuth('/api/cadastros-pendentes');
    if (!res.ok) {
      const data = await res.json();
      throw new Error(data.error || 'Erro ao listar cadastros pendentes');
    }
    return res.json();
  },

  async aprovar(id: string, vendedor_id: string): Promise<{ success: boolean; message: string; parceiro?: unknown; email_enviado?: boolean; email_erro?: string }> {
    const res = await fetchWithAuth(`/api/cadastros-pendentes/${id}/aprovar`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ vendedor_id }),
    });
    let data: { error?: string; code?: string };
    try {
      data = await res.json();
    } catch {
      if (res.status === 404) {
        throw new Error(
          'Rota de aprovação não encontrada (404). Verifique se o backend está em produção e se a URL da API (VITE_API_URL) está correta.'
        );
      }
      throw new Error(res.statusText || 'Erro ao aprovar cadastro.');
    }
    if (!res.ok) throw new Error(data.error || 'Erro ao aprovar cadastro');
    return data as { success: boolean; message: string; parceiro?: unknown; email_enviado?: boolean; email_erro?: string };
  },

  async rejeitar(id: string, motivo_rejeicao?: string): Promise<{ success: boolean; message: string }> {
    const res = await fetchWithAuth(`/api/cadastros-pendentes/${id}/rejeitar`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ motivo_rejeicao: motivo_rejeicao || undefined }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao rejeitar cadastro');
    return data;
  },

  async reenviarEmail(id: string): Promise<{ success: boolean; email_enviado: boolean; message: string }> {
    const res = await fetchWithAuth(`/api/cadastros-pendentes/${id}/reenviar-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || data.message || 'Erro ao reenviar e-mail');
    return data;
  },

  async excluir(id: string): Promise<{ success: boolean; message: string }> {
    const res = await fetchWithAuth(`/api/cadastros-pendentes/${id}/excluir`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Erro ao excluir cadastro');
    return data;
  },
};
